import { Button, Icon, Stack, VStack } from "@chakra-ui/react";
import Footer from "_components/Footer";
import { logEvent } from "helpers/analytics";
import React from "react";
import { Helmet } from "react-helmet";
import ArithmeticsSymbolsCircle from "../../assets/arithmetics-symbols-circle.png";
import TicketCircle from "../../assets/ticket-circle.png";
import BlueFlashCircle from "../../assets/blue-flash-circle.png";
import CreateProfileStep from "../../assets/create-profile-step.png";
import ChooseYourToolsStep from "../../assets/choose-your-tools-step.png";
import ApplyForFinancingStep from "../../assets/apply-for-financing-step.png";
import ApplicationConfirmationStep from "../../assets/application-submitted-step.png";
import SkilledWorkerSmiling from "../../assets/skilled-worker-smiling-full.png";
import { FaArrowRight } from "react-icons/fa";
import SkilledWorkersFAQs from "_components/skilled-workers-landing-pages/SkilledWorkersFAQs";
import { toolsFinancingFAQs } from "./faqs";

export function ToolsFinancingLandingPage() {
  const handleCTAClick = () => {
    logEvent("tools_financing_landing_page_cta_click");

    window.open(`${process.env.REACT_APP_PRO_APPLICATION_URL}/`, "_blank");
  };
  return (
    <>
      <Helmet>
        <title>
          LaborHack Tools Financing - Get the tools you need without breaking
          the bank!
        </title>
      </Helmet>
      <VStack spacing={0} w={"full"}>
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-0 w-full border-t-[1px] border-[#FEFEFE]">
          <div className="bg-[#C55C4D] w-full px-3 lg:px-20 py-8 lg:py-16 flex flex-col gap-8 lg:gap-12 border-[#121212] border-r-[1px] border-b-[1px]">
            <div className="flex flex-col gap-4 lg:gap-6">
              <h1 className="w-full text-3xl lg:text-6xl font-bold text-[#FEFEFE] leading-[42px] lg:leading-[72px]">
                Get the tools you <br className="hidden lg:block" />
                need without <br className="hidden lg:block" />
                breaking the bank!
              </h1>
              <p className="text-lg lg:text-2xl text-[#EAEAEA] w-full lg:w-[85%]">
                {`Struggling to afford the tools essential for your job? With
                LaborHack's flexible tool financing, you can spread payments
                over 1 to 6 months at an affordable 3% APR.`}
              </p>
            </div>
            <Button
              backgroundColor={"#FEFEFE"}
              color={"#ED6E5C"}
              paddingY={{
                base: 6,
                lg: 10,
              }}
              w={"40%"}
              fontSize={{
                base: 15,
                lg: 18,
              }}
              rightIcon={
                <Icon
                  as={FaArrowRight}
                  w={{
                    base: 4,
                    lg: 5,
                  }}
                  h={5}
                  ml={2}
                  className="animate-wiggle"
                />
              }
              onClick={() => handleCTAClick()}
            >
              Get started
            </Button>
          </div>
          <div className="bg-[#F9CFC9] border-[#121212] border-b-[1px] flex items-center justify-center py-12 lg:py-16">
            <div className="w-[90%] lg:w-[592px] h[360px] lg:h-[470px]">
              <img
                className="w-full h-full"
                src={SkilledWorkerSmiling}
                alt="Skilled worker smiling"
              />
            </div>
          </div>
        </section>
        <section className="flex flex-col gap-0 w-full">
          <div className="w-full flex flex-col items-center justify-center px-3 lg:px-10 py-10 lg:py-14 gap-4 lg:gap-5">
            <h3 className="text-[20px] lg:text-[48px] font-medium text-[#122A38] text-center">
              Enjoy up to ₦500,000
              <br className="" />
              worth of tool financing
            </h3>
          </div>
          <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-0 border-[#121212] border-t-[1px] border-b-[1px]">
            <div className="py-4 lg:py-8 px-3 lg:px-20 border-[#121212] lg:border-r-[1px] border-b-[1px] lg:border-b-0 flex flex-col items-start gap-6">
              <div className="w-14 h-14 lg:w-24 lg:h-24 rounded-full">
                <img
                  src={ArithmeticsSymbolsCircle}
                  alt="arithmetics symbols icon"
                />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[14px] lg:text-[24px] font-semibold text-[#212121]">
                  {`Affordable financing`}
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Access tools with a minimum of 20% deposit and 3% APR
                </p>
              </div>
            </div>

            <div className="py-4 lg:py-8 px-3 lg:px-20 border-[#121212] lg:border-r-[1px] border-b-[1px] lg:border-b-0 flex flex-col items-start gap-6">
              <div className="w-14 h-14 lg:w-24 lg:h-24 rounded-full">
                <img src={TicketCircle} alt="ticket icon" />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[14px] lg:text-[24px] font-semibold text-[#212121]">
                  Flexible payment plans
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Choose repayment terms that fit your financial capacity.
                </p>
              </div>
            </div>

            <div className="py-4 lg:py-8 px-3 lg:px-20 lg:border-[#121212] border-b-[1px] lg:border-b-0  flex flex-col items-start gap-6">
              <div className="w-14 h-14 lg:w-24 lg:h-24 rounded-full">
                <img src={BlueFlashCircle} alt="blue flash icon" />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[14px] lg:text-[24px] font-semibold text-[#212121]">
                  Quick application process
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Get your tools quickly within 48 hours
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="w-full flex flex-col gap-4 lg:gap-8">
          <div className="px-3 lg:px-20 py-8 lg:py-16 flex flex-row items-center justify-between border-[#121212] border-b-[1px]">
            <div className="flex flex-col gap-4 w-[full]">
              <h2 className="text-xl lg:text-5xl text-[#122A38] font-medium lg:leading-[56px]">
                Get the tools you <br /> need in a few steps
              </h2>
            </div>
            <div className="w-[50%] lg:w-[30%] flex justify-end">
              <Button
                backgroundColor={"#040A0D"}
                color={"#FEFEFE"}
                paddingY={{
                  base: 6,
                  lg: 10,
                }}
                w={{
                  base: "70%",
                  lg: "70%",
                }}
                fontSize={{
                  base: "12px",
                  lg: "26px",
                }}
                rightIcon={
                  <Icon
                    as={FaArrowRight}
                    w={{
                      base: 4,
                      lg: 5,
                    }}
                    h={{
                      base: 3,
                      lg: 5,
                    }}
                    ml={1}
                    className="animate-wiggle"
                  />
                }
                onClick={() => handleCTAClick()}
              >
                Get started
              </Button>
            </div>
          </div>
          <div className="border-[#121212] border-b-[1px] w-full py-12 lg:px-20 flex flex-col lg:flex-row gap-12 lg:gap-6">
            <div className="px-3 lg:px-0 pb-8 lg:pb-0 border-[#121212] border-b-[1px] lg:border-b-0 w-full lg:w-1/3 flex flex-col items-start gap-6">
              <div className="w-fit h-fit">
                <img
                  className="min-h-[205px] lg:min-h-[232px]"
                  src={CreateProfileStep}
                  alt="create profile step"
                />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[16px] lg:text-[24px] font-medium lg:font-semibold text-[#212121]">
                  Create your profile
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Sign up on LaborHack and fill in your biodata and contact
                  details.
                </p>
              </div>
            </div>

            <div className="px-3 lg:px-0 pb-8 lg:pb-0 border-[#121212] border-b-[1px] lg:border-b-0 w-full lg:w-1/3 flex flex-col items-start gap-6">
              <div className="w-fit h-fit">
                <img
                  className="min-h-[205px] lg:min-h-[232px]"
                  src={ChooseYourToolsStep}
                  alt="choose your tools step"
                />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[16px] lg:text-[24px] font-medium lg:font-semibold text-[#212121]">
                  Choose your tools
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Click on the tool financing tab on your dashboard and browse a
                  catalog of high-quality tools tailored to your craft.
                </p>
              </div>
            </div>
            <div className="px-3 lg:px-0 pb-8 lg:pb-0 border-[#121212] border-b-[1px] lg:border-b-0 w-full lg:w-1/3 flex flex-col items-start gap-6">
              <div className="w-fit h-fit">
                <img
                  className="min-h-[205px] lg:min-h-[232px]"
                  src={ApplyForFinancingStep}
                  alt="apply for financing step"
                />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[16px] lg:text-[24px] font-medium lg:font-semibold text-[#212121]">
                  Apply for financing
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Select your preferred tool and submit your financing
                  application.
                </p>
              </div>
            </div>

            <div className="px-3 lg:px-0  w-full lg:w-1/3 flex flex-col items-start gap-6">
              <div className="w-fit h-fit">
                <img
                  className="min-h-[205px] lg:min-h-[232px]"
                  src={ApplicationConfirmationStep}
                  alt="tools application confirmation"
                />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[16px] lg:text-[24px] font-medium lg:font-semibold text-[#212121]">
                  Voila! Your tools arrive soon.
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Once approved, pick up your tools or get them delivered to
                  your doorstep.
                </p>
              </div>
            </div>
          </div>
        </section>
        <SkilledWorkersFAQs items={toolsFinancingFAQs} />
        <section className="px-6 py-14 lg:py-16 w-full bg-[#FBE2DE] flex flex-col text-center items-center gap-6 lg:gap-10">
          <div className="w-[95%] lg:w-[55%] flex flex-col gap-4 lg:gap-6 justify-center items-center">
            <h3 className="text-[18px] lg:text-[48px] font-medium text-[#2F1612]">
              Access quick tool <br className="" /> financing - no fuss
            </h3>
            <p className="w-[96%] lg:w-[63%] text-base lg:text-2xl text-[#2F1612]">
              Upgrade your equipment and grow your business without the
              financial strain.
            </p>
          </div>
          <div className="w-full">
            <Button
              backgroundColor={"#FEFEFE"}
              color={"#2F1612"}
              paddingY={{
                base: 6,
                lg: 10,
              }}
              w={{
                base: "60%",
                lg: "25%",
              }}
              paddingX={{
                base: 8,
                lg: 10,
              }}
              fontSize={{
                base: 15,
                lg: 22,
              }}
              rightIcon={
                <Icon
                  as={FaArrowRight}
                  w={{
                    base: 4,
                    lg: 5,
                  }}
                  h={{
                    base: 4,
                    lg: 5,
                  }}
                  ml={2}
                  className="animate-wiggle"
                />
              }
              onClick={() => handleCTAClick()}
            >
              Apply for financing
            </Button>
          </div>
        </section>
      </VStack>
      <Footer />
    </>
  );
}
